const GRAPHEME_SEGMENTER =
  typeof Intl.Segmenter === 'function'
    ? new Intl.Segmenter(undefined, { granularity: 'grapheme' })
    : null;

export function getAvatarInitials(name: string): string {
  const normalizedName = name.trim().toLocaleUpperCase().normalize('NFC');
  if (!normalizedName) return '';

  const words = normalizedName.split(/\s+/u);
  const getGraphemes = (value: string) =>
    GRAPHEME_SEGMENTER
      ? Array.from(GRAPHEME_SEGMENTER.segment(value), segment => segment.segment)
      : Array.from(value);

  if (words.length === 1) {
    return getGraphemes(words[0]).slice(0, 2).join('');
  }

  const firstInitial = getGraphemes(words[0])[0] ?? '';
  const lastInitial = getGraphemes(words[words.length - 1])[0] ?? '';
  return `${firstInitial}${lastInitial}`;
}

